import { AxModal, AxDropdown, IAxDropdownOptions, AxFormValidation, AxInput, IAxFormValidationOptions } from "@axess/limestone";
import { inputMaskHelper } from "../../../../Lib/Helper/InputMaskHelper";
import { ProductAndRiderDetails as RentalAddToCartProduct } from "../../../../Models/Rental/RiderDetails/ProductAndRiderDetails";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import * as Rental from "../RiderDetailsModule";

export class LockerData {
    private lockerWtpSelectionDropdown = new AxDropdown();
    private riderDetailsModule: Rental.RiderDetailsModule;

    constructor() {
        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");

        this.initLockerDropDown();
        this.initLockerValidation();
    }

    initLockerValidation() {
        let validationFormOptions = {
            selector: '#lockerDataForm',
            rules: this.getLockerValidationRules(),
            callback: (form: HTMLElement) => {}
        }

        let form = document.getElementById('lockerDataForm');

        let inputs = form.getElementsByClassName("ax-form-control rental_customer_details-wtp_inp");

        new AxFormValidation(validationFormOptions).init();

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs.item(i) as HTMLInputElement;

            if (input.id.length === 0) {
                continue;
            }

            new AxInput('#' + input.id).init();
        }
    }

    lockerFormIsValid(): Promise<boolean> {
        if (this.riderDetailsModule.getActiveProductPortlet().getProductAndRiderDetails().lockerWtpSelection === 2
            || this.riderDetailsModule.getActiveProductPortlet().getProductAndRiderDetails().lockerWtpSelection === 3) {
            return Promise.resolve(true);
        }

        let valid = $('#lockerDataForm')?.valid();

        if (!valid) {
            return Promise.resolve(false);
        }

        return new Promise((resolve, reject) => {
            AxessViewer.ajaxRequest("/util/checkwtpnr", { wtpnr: $('[name=rentalLockerWtpNr]').val() }, (resp) => {
                resolve(resp);
            }, {});
        })
    }

    private getLockerValidationRules(): JQueryValidation.RulesDictionary {
        return {
            rentalLockerWtpNr: {
                required: {
                    depends: (element) => {
                        return true;
                    }
                },
                wtpNumber: {
                    depends: (element) => {
                        return true;
                    }
                }
            }
        };
    }

    private initLockerDropDown() {
        this.lockerWtpSelectionDropdown.init('.rental_customer_details-lockerWtp',
            {
                onSelect: (p, value: string) => {
                    this.lockerSelectionUpdate(p, value);
                }
            });

        $('.rental_customer_details-wtp_inp').inputmask(inputMaskHelper.wtpNumberMask(), inputMaskHelper.wtpMaskOptions());

        $('.rental_customer_details-wtp_inp').on('keyup', x => {
            if ($('.rental_customer_details-wtp_inp').inputmask("isComplete")) {
                this.riderDetailsModule.getActiveProductPortlet().checkFormValidityAndSetStates();
                this.riderDetailsModule.getActiveProductPortlet().getProductAndRiderDetails().lockerWtpNr = $('.rental_customer_details-wtp_inp').val() as string;
            }
        });
    }

    setLockerData(productAndRiderDetails: RentalAddToCartProduct) {
        if (productAndRiderDetails != null) {
            switch (productAndRiderDetails.lockerWtpSelection) {
                case 0:
                    break;
                case 3:
                    this.lockerWtpSelectionDropdown.setValue(productAndRiderDetails.lockerWtpNr);
                    break;
                //no break since default should still run
                case 2:
                    $('.rental_customer_details-wtp_inp').val(productAndRiderDetails.lockerWtpNr);
                default:
                    // remember wtpNr cause Dropdown.setValue will override it with empty string
                    const lockerWtpNrTemp = productAndRiderDetails.lockerWtpNr;
                    this.lockerWtpSelectionDropdown.setValue((productAndRiderDetails.lockerWtpSelection * -1).toString());
                    $('.rental_customer_details-wtp_inp').val(lockerWtpNrTemp);
                    productAndRiderDetails.lockerWtpNr = lockerWtpNrTemp;
                    break;
            }
        }
    }

    private lockerSelectionUpdate(parent: JQuery<HTMLElement>, value: string) {
        const intValue = parseInt(value);
        let productAndRiderDetails = this.riderDetailsModule.getActiveProductPortlet().getProductAndRiderDetails();

        if (!isNaN(intValue) && intValue < 0) {
            productAndRiderDetails.lockerWtpSelection = intValue * -1;

            if (intValue === -1) {
                productAndRiderDetails.lockerWtpNr = $('.rental_customer_details-wtp_inp').val() as string;
            } else {
                productAndRiderDetails.lockerWtpNr = "";
            }

        } else {
            productAndRiderDetails.lockerWtpNr = value;
            productAndRiderDetails.lockerWtpSelection = 3;
        }


        $('.rental_customer_details-lockerWtp--warning').toggleClass('d-none', value !== '-2');
        $('.rental_customer_details-wtp_inp-wrapper').toggleClass('d-none', value !== '-1');

        this.riderDetailsModule.getActiveProductPortlet().setLockerWtpNumberText(parent, value);
        this.riderDetailsModule.getActiveProductPortlet().checkFormValidityAndSetStates();
    }

    lockerRequired(): boolean {
        return this.lockerWtpSelectionDropdown != null && this.lockerWtpSelectionDropdown.val() === "-1";
    }
}